/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: Nxr1hsnMCUh9
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicPartnerAvatarPannel.module.css"; // plasmic-import: Nxr1hsnMCUh9/css

createPlasmicElementProxy;

export const PlasmicPartnerAvatarPannel__VariantProps = new Array("isVisible");

export const PlasmicPartnerAvatarPannel__ArgProps = new Array();

const $$ = {};

function PlasmicPartnerAvatarPannel__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isVisible",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => $props.isVisible
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        { [sty.rootisVisible]: hasVariant($state, "isVisible", "isVisible") }
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__kkKYi)}>
        <div
          className={classNames(projectcss.all, sty.freeBox__dLmXg, {
            [sty.freeBoxisVisible__dLmXGcv11G]: hasVariant(
              $state,
              "isVisible",
              "isVisible"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__eaw8I
            )}
          >
            {"cristian popa"}
          </div>
        </div>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__rLuva
          )}
        >
          {"Co-founder of haaaven, architect at o21p."}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPartnerAvatarPannel__ArgProps,
          internalVariantPropNames: PlasmicPartnerAvatarPannel__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPartnerAvatarPannel__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPartnerAvatarPannel";
  } else {
    func.displayName = `PlasmicPartnerAvatarPannel.${nodeName}`;
  }
  return func;
}

export const PlasmicPartnerAvatarPannel = Object.assign(
  // Top-level PlasmicPartnerAvatarPannel renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicPartnerAvatarPannel
    internalVariantProps: PlasmicPartnerAvatarPannel__VariantProps,
    internalArgProps: PlasmicPartnerAvatarPannel__ArgProps
  }
);

export default PlasmicPartnerAvatarPannel;
/* prettier-ignore-end */
